import { Grid, Skeleton } from '@mui/material';
import type React from 'react';
import { useMemo } from 'react';

export type LoadingRectanglesProps = {
  readonly count?: number;
  readonly height?: string;
};

const LoadingRectangles: React.FC<LoadingRectanglesProps> = (props: LoadingRectanglesProps) => {
  const { count, height } = props;

  const rectList = useMemo(() => {
    return Array(count)
      .fill('')
      .map((_, idx: number) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: intentionally using index as key
        <Grid item xs={12} key={idx}>
          <Skeleton variant="rectangular" width="100%" height={height} />
        </Grid>
      ));
  }, [count, height]);

  return (
    <Grid container spacing={1}>
      {rectList}
    </Grid>
  );
};

LoadingRectangles.defaultProps = {
  count: 3,
  height: '4rem'
};

export default LoadingRectangles;
